module.exports = __webpack_public_path__ + "media/images/blue-calendar-97248b4deb04eecac47851c5666b8d04.png";